import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    quote: 'I have tried every spreadsheet template out there, and GTBuy is hands down the most intuitive one. The profit calculator alone has saved me from making bad sourcing decisions more times than I can count.',
    name: 'Marcus Chen',
    role: 'Amazon FBA Seller',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20early%2030s%20with%20short%20neat%20black%20hair%2C%20warm%20approachable%20expression%2C%20wearing%20a%20crisp%20white%20oxford%20shirt%2C%20light%20sand%20colored%20studio%20background%2C%20soft%20diffused%20lighting%2C%20minimalist%20portrait%20photography&width=120&height=120&seq=testim-avatar-1-v2&orientation=squarish',
    rating: 5,
  },
  {
    id: 2,
    quote: 'As someone who manages over 500 SKUs across three platforms, I needed something that would not slow me down. GTBuy Spreadsheet gives me the speed and clarity I need to scale.',
    name: 'Jennifer Park',
    role: 'Multi-Platform Reseller',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20mid%2030s%20with%20long%20straight%20dark%20brown%20hair%2C%20kind%20confident%20smile%2C%20wearing%20an%20off-white%20cashmere%20sweater%2C%20soft%20cream%20studio%20background%2C%20gentle%20diffused%20lighting%2C%20minimalist%20portrait%20photography&width=120&height=120&seq=testim-avatar-2-v2&orientation=squarish',
    rating: 5,
  },
  {
    id: 3,
    quote: 'I was skeptical about yet another spreadsheet tool, but GTBuy won me over in the first week. The order tracking dashboard alone is worth every penny — my fulfillment accuracy has never been better.',
    name: 'David Okonkwo',
    role: 'Dropshipping Entrepreneur',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20man%20late%2020s%20with%20closely%20cropped%20hair%2C%20composed%20self-assured%20expression%2C%20wearing%20a%20light%20charcoal%20henley%20shirt%2C%20warm%20oyster%20studio%20background%2C%20soft%20natural%20portrait%20lighting%2C%20minimalist%20professional%20photography&width=120&height=120&seq=testim-avatar-3-v2&orientation=squarish',
    rating: 5,
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-14">
          <span className="text-2xl md:text-3xl font-serif italic text-foreground-300">(</span>
          <h2 className="text-2xl md:text-3xl font-serif italic text-foreground-900">
            What Resellers Say
          </h2>
          <span className="text-2xl md:text-3xl font-serif italic text-foreground-300">)</span>
        </div>

        <div className="flex items-center justify-center gap-2 mb-8">
          <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-foreground-900 text-white text-xs font-semibold whitespace-nowrap">
            <i className="ri-star-fill text-amber-400 text-sm"></i>
            4.9 / 5
          </span>
        </div>

        <blockquote className="text-xl md:text-2xl text-foreground-800 font-serif italic leading-relaxed mb-10 transition-opacity duration-300">
          &ldquo;{t.quote}&rdquo;
        </blockquote>

        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden flex-shrink-0">
            <img
              src={t.avatar}
              alt={t.name}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
            <p className="text-xs text-foreground-500">{t.role}</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2">
          <button
            onClick={prev}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 hover:border-foreground-400 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-line text-foreground-600"></i>
          </button>
          <button
            onClick={next}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 hover:bg-foreground-800 text-white transition-all duration-200 cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="flex items-center justify-center gap-2 mt-6">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                idx === current ? 'bg-foreground-900 w-6' : 'bg-background-300 hover:bg-background-400'
              }`}
              aria-label={`Go to testimonial ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}